// extracted by mini-css-extract-plugin
module.exports = {"waffle":"styles_waffle__28h0K","loading":"styles_loading__1uAZv","waffle-verticalScrollDisabled":"styles_waffle-verticalScrollDisabled__3NoKt"};